/**
 * PageSubHeader - sub-header bar below AppHeader
 *
 * Uses a subtle emerald/green bottom border accent from the brand palette.
 *
 * @param title   - page title
 * @param subtitle - optional description
 * @param action  - optional right-side ReactNode (button, link, etc.)
 */

import type { ReactNode } from 'react';

interface PageSubHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageSubHeader({ title, subtitle, action }: PageSubHeaderProps) {
  return (
    <div className="no-print bg-zinc-900/60 border-b border-zinc-800">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white">{title}</h1>
            {subtitle && <p className="text-sm text-zinc-400 mt-0.5">{subtitle}</p>}
          </div>
          {action}
        </div>
      </div>
    </div>
  );
}
